import React from 'react';
import Spinner from "../../components/Spinner";

const Step100 = () => <Spinner/>;

export default Step100;
